import { Text } from '@shared/components';
import { TextFieldArray } from '@shared/components/react-hook-form';
import ReactHookFormCheckbox from '@shared/components/react-hook-form/ReactHookFormCheckbox';
import { StyleProps } from '@shared/utils';
import { getUserFeatureDisplayName } from '@shared/utils/userFeatures/getUserFeatureDisplayName';
import { ReactElement } from 'react';
import { Control } from 'react-hook-form';
import { EmailScanningFeatureFormValues } from './utils/featuresForm';

export type EmailScanningFeatureFormProps = StyleProps & {
  el: (strings: TemplateStringsArray) => string;
  control: Control<EmailScanningFeatureFormValues, object>;
};

function EmailScanningFeatureForm({
  el,
  control,
}: EmailScanningFeatureFormProps): ReactElement {
  return (
    <div className={el`email-classification`}>
      <div className={el`feature-container`}>
        <ReactHookFormCheckbox
          label={getUserFeatureDisplayName('EmailScanning')}
          control={control}
          name={'enabled'}
          labelType="body-sm"
        />
        <Text type="body-xs" className={el`feature-description`}>
          With email monitoring enabled, Vooma will build quotes or orders
          automatically for emails that are not blocked.
        </Text>
        <TextFieldArray
          control={control}
          name={'blockList'}
          arrayLabel="Blocked email addresses"
          elementLabel="blocked email"
        />
      </div>
    </div>
  );
}

export default EmailScanningFeatureForm;
